import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-pay-layout.component.html',
  styleUrls: ['./auth-pay-layout.component.scss']
})
export class AuthPayLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
